module.exports = __webpack_public_path__ + "static/media/24b.92fa9a7b.jpg";